import { render } from "./BoleteriaScanner.vue?vue&type=template&id=bc705bce&scoped=true"
import script from "./BoleteriaScanner.vue?vue&type=script&lang=js"
export * from "./BoleteriaScanner.vue?vue&type=script&lang=js"

import "./BoleteriaScanner.vue?vue&type=style&index=0&id=bc705bce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc705bce"]])

export default __exports__